import React from 'react';
import SkeletonBlock from '../ui/SkeletonBlock';
import SkeletonRoot from '../ui/SkeletonRoot';
import { Card, CardContent, CardHeader } from '../ui';
import PipelineSalesTableSkeleton from '../admin/pipeline/PipelineSalesTableSkeleton';
import { ProspectMetricTilesSkeleton } from './metricTileSkeletons';

function PipelineToolbarSkeleton() {
  return (
    <div className="flex min-w-0 flex-col gap-2.5" aria-hidden>
      <div className="flex flex-wrap items-center gap-2">
        <SkeletonBlock className="h-9 w-[108px] rounded-lg" />
        <SkeletonBlock className="h-9 w-[108px] rounded-lg" />
        <SkeletonBlock className="h-9 w-[108px] rounded-lg" />
        <SkeletonBlock className="ml-auto h-9 w-[220px] rounded-lg" />
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <SkeletonBlock className="h-9 min-w-[200px] flex-1 max-w-md rounded-lg" />
        <SkeletonBlock className="h-9 w-24 rounded-lg" />
        <SkeletonBlock className="h-9 w-28 rounded-lg" />
        <SkeletonBlock className="h-9 w-28 rounded-lg" />
        <SkeletonBlock className="h-9 w-24 rounded-lg" />
      </div>
    </div>
  );
}

interface PipelinePageSkeletonProps {
  loadingLabel?: string;
}

/**
 * Route-level pipeline page skeleton — title, metric tiles, toolbar card, sales table.
 */
const PipelinePageSkeleton: React.FC<PipelinePageSkeletonProps> = ({
  loadingLabel = 'Loading pipeline',
}) => (
  <SkeletonRoot loadingLabel={loadingLabel}>
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-[1400px] px-4 py-4 sm:px-6 lg:px-8">
        <SkeletonBlock className="mb-4 h-8 w-32 rounded-lg" />
        <ProspectMetricTilesSkeleton />
        <Card className="mb-8 border-primary-500/10 bg-gradient-to-br from-white to-primary-500/2 shadow-xl">
          <CardHeader className="pb-4">
            <PipelineToolbarSkeleton />
          </CardHeader>
          <CardContent>
            <div className="relative min-h-[520px] overflow-x-auto">
              <PipelineSalesTableSkeleton rows={10} />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  </SkeletonRoot>
);

export default PipelinePageSkeleton;
